import React, { useState ,useEffect } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import InfoBox from './InfoBox';
import styles from './add-variant.scss';
import withRipple from 'jd-library/withRipple';
import { showVariantOptionsSlider, showVariantTypeSlider, showVariantDetailsSlider, createVariantCombinations,showEditVariantSlider } from '../../../actions/variants';
import { connect } from 'react-redux';
import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import toastMessageActions from 'jd-library/toastMessageActions';

const AddVariantOptions = props => {
    const { variantData } = props;
    const [variantOptions,updateVariantOptions] = useState({});
    const [comboCount,updateCount] = useState(0);

    const openOptionSlider = (data) => {
        let variantSelected = Object.keys(variantOptions)?.length;
        if(variantSelected >= 3 && !Object.keys(variantOptions).includes(data.specName)) {
            props.showToast({
                message: 'Variant Options can be Added to Maximum of 3 Variant Types',
                type: 'error',
                bottom: props.hasGlassFooter ? '80px' : '0px'
            })
        }else {
            props.showVariantOptionsSlider({
                show: true,
                mode: variantOptions[data.specName]?.length && props.productId != 'ADD_PRODUCT'?'edit-product':variantOptions[data.specName]?.length?'edit':'add',
                keyType: data.specName,
                index: props.variantData?.findIndex(el => el.type == data.specName)
            })
        }

    }

    const SingleRow = withRipple((props) => {
        const { data } = props;
        const hasOptions = variantOptions[data.specName]?.length;
        return (
            <div 
            className={`${styles["section-container"]} ${props.rippleClass} ${styles[hasOptions?'options':'']}`} {...props.rippleHandler} 
            onClick={() => openOptionSlider(data)}>
                <div className={styles["head-text"]}>
                    <span>{data.specName}</span>
                    <i className={"icon-Next"}></i>
                    <div className={styles['variant-holder']}>
                    {hasOptions?
                        <div className={styles['specs-holder']}>
                            {variantOptions[data.specName].toString().replaceAll(',', ', ')}
                        </div>
                    :
                        <>
                            <i className={'icon-plus'} />
                            <span>Add Variant Options</span>
                        </>
                    }
                    </div>
                </div>
                {props.renderRipple()}
            </div>
        )
    })
    const calculateCombination = (data) => {
        let combo = 1;
        let keysArr = Object.keys(data);
        if(keysArr?.length) {
            keysArr.map(cur => {
                combo*=data[cur].length;
            })
            updateCount(combo);
        }
    }

    useEffect(() => {
        if(variantData.length) {
            let variantObj = {...variantOptions};
            variantData.map(cur => {
                variantObj[cur.type] = cur.options;
            })
            calculateCombination(variantObj);
            updateVariantOptions({...variantObj});
            props.createVariantCombinations(variantData, props.productId != 'ADD_PRODUCT');
        }
    },[variantData])

    const onSave = () => {
        let errMsg = '';
        if(comboCount == 0) {
            errMsg = 'Please Add Variant Option in One of the Variant type';
        }else if(comboCount > 20) {
            errMsg = `Maximum of 300 Variant ${props.isService?'Services':'Products'} are allowed`;
        }
        if(errMsg){
            props.showToast({
                message: errMsg,
                type: 'info',
                bottom: props.hasGlassFooter ? '80px' : '0px'
            })
            return;
        }else {            
            props.showVariantDetailsSlider({
                show: true,
                mode: props.isEdit ? 'edit' : 'add'
            })
        }
    }

    const Footer = () => (
        <div className={styles['footer-holder']}>
            <div className={styles['combination-txt']}>
                <span>{`Total ${props.isService? 'Service': 'Product'} Variants`}</span>
                <span className={styles['count']}>{comboCount}</span>
            </div>
            <Button className={styles['footer-btn']} children={'Save'} clickHandler={onSave} />
        </div>
    )

    return (
        <SliderWrapper
        onHidden={() => {
            props.showVariantTypeSlider({
                show: false
            });
            props.showEditVariantSlider(false);
    }}
        animateChildren={false}
        header={{
            leftIcons: [{
                className: "icon-hdrBackNew",
                onClick: () => {
                  historyHandler.closeCurrent();
                },
              }],
              rightIcons: (props.deviceData.isMobile || props.isService)?  [] : [{
                className: 'icon-HDRcross',
                onClick: () => {
                    historyHandler.closeAll(); 
                }
            }],
            heading: `${props.isEdit ? 'Edit' : 'Add'} Variant Options`
        }}
        >
            <div className={styles['add-option-slider']}>
                <InfoBox 
                    data={'You can define variant options in maximum of 3 variant types'}
                />
                {props.variantSpec.map(cur => {
                    if((props.productId == "ADD_PRODUCT" || variantOptions[cur]?.length) || !variantData.length) {
                        return (<SingleRow {...props} data={{
                            specName: cur
                        }}
                        showVariantOptionsSlider={props.showVariantOptionsSlider}
                        />)
                    }
                })}
                <Footer /> 
            </div>

        </SliderWrapper>
    );
};

const mapStateToProps = (state,props) => {
    return {
        deviceData : state.deviceData,
        variantData: state.variants.variantData,
        isEdit: state.products.editProduct.isEdit,
        variantSpec: state.variants.variantSpec,
        productId: state.products.editProduct.productId,
        isService: state.products.editProduct.categoryType == 'service'
    }
}
export default connect(mapStateToProps,{
    showVariantOptionsSlider,
    showVariantTypeSlider,
    showVariantDetailsSlider,
    showToast: toastMessageActions.showMessage,
    createVariantCombinations,
    showEditVariantSlider
})(AddVariantOptions);